import React from 'react';
import { AlertCircle } from 'lucide-react';

const ConfirmDialog = ({ isOpen, onCancel, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-[100] animate-in fade-in duration-300">
      <div className="bg-white rounded-[2.5rem] p-8 shadow-2xl max-sm:w-[90%] w-full max-w-sm mx-4 transform animate-in slide-in-from-bottom-4 duration-300 border border-gray-100">
        <div className="w-16 h-16 bg-rose-50 rounded-full flex items-center justify-center text-rose-500 mx-auto mb-6">
          <AlertCircle size={32} />
        </div>
        <h3 className="text-xl font-bold text-gray-900 text-center mb-2">Cancel Order</h3>
        <p className="text-gray-500 text-center mb-8 font-medium">Are you sure you want to cancel this order? This action cannot be undone.</p>
        <div className="flex gap-4">
          <button
            className="flex-1 px-6 py-3 rounded-2xl bg-gray-50 text-gray-600 font-bold hover:bg-gray-100 transition-all text-xs tracking-widest uppercase"
            onClick={onCancel}
          >
            Go Back
          </button>
          <button
            className="flex-1 px-6 py-3 rounded-2xl bg-rose-500 text-white font-bold shadow-lg shadow-rose-200 hover:scale-105 transition-all text-xs tracking-widest uppercase"
            onClick={onConfirm}
          >
            Cancel Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
